export const handleSubmitFile = async (method: () => Promise<any>) => {
  try {
    const response = await method();
    if (response && response.status === 200 && response.data) {
      const contentDisposition = response.headers["content-disposition"];
      const filenameMatch =
        contentDisposition &&
        contentDisposition.match(/filename[^;=\n]*=(['"]?)([^'"\n]*)\1/);
      const filename = filenameMatch
        ? filenameMatch[2]
        : "Indicadores_SISAN.xlsx";

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet ",
      });
      return new File([blob], filename, { type: blob.type });
    } else {
      throw new Error();
    }
  } catch (error) {
    console.error("API Error:", error);
    return false;
  }
};
